import { selectAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(selectAnatomy.keys);

export const selectRecipe = {
  ...defineMultiStyleConfig({
    baseStyle: definePartsStyle(({ isInvalid }) => ({
      field: {
        border: '1.2px solid',
        borderColor: isInvalid ? 'error.500' : 'transparent',
        boxShadow: 'none',
        fontSize: { base: 'sm', md: 'md' },
        _focusVisible: {
          borderWidth: '1.2px',
          borderColor: isInvalid ? 'error.500' : 'gray.800',
        },
      },
      icon: {
        color: 'primary.500',
      },
    })),
    sizes: {
      md: {
        field: {
          h: '40px',
          borderRadius: 'md',
          px: '4',
          py: '2.5',
          my: '5px',
        },
      },
      lg: {
        field: {
          h: '50px',
          borderRadius: 'sm',
          px: '4',
          py: '4',
          my: '9px',
        },
      },
      xl: {
        field: {
          h: '76px',
          borderRadius: 'sm',
          px: '6',
          py: '6',
          my: '3',
        },
      },
    },
    variants: {
      outline: {
        field: {
          color: 'gray.800',
          bg: 'white',
          border: '1.2px solid',
          borderColor: 'gray.700',
          _placeholder: {
            color: 'gray.700',
          },
        },
      },
      ghost: {
        field: {
          bgColor: 'white',
        },
      },
      filled: definePartsStyle(({ isInvalid }) => ({
        field: {
          color: 'gray.700',
          bg: 'grayAlpha.200',
          border: '1.2px solid',
          _hover: {
            bg: 'grayAlpha.200',
          },
          _focusVisible: {
            bg: 'grayAlpha.200',
            borderColor: isInvalid ? 'error.500' : 'gray.800',
          },
          _placeholder: {
            color: 'gray.600',
          },
        },
      })),
    },
    defaultProps: {
      size: 'md',
      variant: 'filled',
      colorScheme: 'white',
    },
  }),
};

export default selectRecipe;
